<template>
<div class="chapter">
<div class="inner_page">
<a id="page_i"></a>
<p class="half"><span class="bold">ACE OF THE BLACK CROSS</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Halftitle.vue?874df018